import React, { useState } from "react";
import {
  TextField,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Box,
  InputAdornment,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { toggleCountrySelectDrawerOpen } from "../redux/uiSlice";
import { getCountryPhoneNumberFormat } from "../utils/phoneNumberUtil";

interface Country {
  code: string;
  name: string;
  phoneCode: string;
}

const PhoneConnectInput: React.FC = () => {
  const { selectedCountry } = useAppSelector((state) => state.countries);
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useAppDispatch();

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    let formattedValue = "";

    // Format as (000) 000-0000
    if (value.length > 0) {
      formattedValue = `(${value.substring(0, 3)}`;
    }
    if (value.length > 3) {
      formattedValue += `) ${value.substring(3, 6)}`;
    }
    if (value.length > 6) {
      formattedValue += `-${value.substring(6, 10)}`;
    }

    setPhoneNumber(formattedValue);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        variant="outlined"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        placeholder={getCountryPhoneNumberFormat(
          selectedCountry?.twoLetterIsoCode || ""
        )}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Paper
                variant="outlined"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 56,
                  height: 32,
                  bgcolor: "black",
                  color: "white",
                  borderRadius: 1,
                  cursor: "pointer",
                  mr: 1,
                }}
                onClick={() => dispatch(toggleCountrySelectDrawerOpen())}
              >
                <Typography variant="body2">
                  {selectedCountry?.twoLetterIsoCode}
                </Typography>
              </Paper>
              <Typography variant="body1" sx={{ ml: 1 }}>
                {selectedCountry?.phoneCode}
              </Typography>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default PhoneConnectInput;
